var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c("section-title", { attrs: { icon: "mdi-alert-plus-outline" } }, [
        _vm._v("Datos de la interrupción")
      ]),
      _c(
        "v-card",
        { staticClass: "pa-4" },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { "lazy-validation": "" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Número de incidente",
                          type: "number",
                          autofocus: "",
                          rules: [_vm.rules.required()],
                          required: "",
                          min: "1",
                          "prepend-icon": "mdi-counter"
                        },
                        model: {
                          value: _vm.newIncident.number,
                          callback: function($$v) {
                            _vm.$set(_vm.newIncident, "number", $$v)
                          },
                          expression: "newIncident.number"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          label: "Lugar",
                          "item-text": "name",
                          "item-value": "id",
                          rules: [_vm.rules.required()],
                          loading: _vm.isFetchingData,
                          items: _vm.view.locations,
                          required: "",
                          "prepend-icon": "mdi-map-marker",
                          "no-data-text": "No hay lugares disponibles"
                        },
                        model: {
                          value: _vm.newIncident.dataCenter,
                          callback: function($$v) {
                            _vm.$set(_vm.newIncident, "dataCenter", $$v)
                          },
                          expression: "newIncident.dataCenter"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-select", {
                        attrs: {
                          label: "Causa de la interrupción",
                          required: "",
                          rules: [_vm.rules.required()],
                          items: _vm.view.causes,
                          loading: _vm.isFetchingData,
                          "prepend-icon": "mdi-help-rhombus-outline",
                          "item-value": "id",
                          "item-text": "name",
                          "no-data-text": "No hay causas disponibles"
                        },
                        model: {
                          value: _vm.newIncident.incidentCause,
                          callback: function($$v) {
                            _vm.$set(_vm.newIncident, "incidentCause", $$v)
                          },
                          expression: "newIncident.incidentCause"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "nudge-right": 40,
                            transition: "scale-transition",
                            "offset-y": "",
                            "max-width": "290px",
                            "min-width": "290px"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "v-text-field",
                                    _vm._g(
                                      {
                                        attrs: {
                                          rules: [_vm.rules.required()],
                                          label:
                                            "Fecha de inicio de la interrupción",
                                          readonly: "",
                                          "prepend-icon": "mdi-calendar"
                                        },
                                        model: {
                                          value: _vm.dateStart,
                                          callback: function($$v) {
                                            _vm.dateStart = $$v
                                          },
                                          expression: "dateStart"
                                        }
                                      },
                                      on
                                    )
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.dateStartMenu,
                            callback: function($$v) {
                              _vm.dateStartMenu = $$v
                            },
                            expression: "dateStartMenu"
                          }
                        },
                        [
                          _c("v-date-picker", {
                            attrs: {
                              locale: "es",
                              color: "#60BB46",
                              max: _vm.maxDate,
                              "header-color": "rgb(64,139,56)",
                              "no-title": ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.setDateStart($event)
                              }
                            },
                            model: {
                              value: _vm.dateStartSelected,
                              callback: function($$v) {
                                _vm.dateStartSelected = $$v
                              },
                              expression: "dateStartSelected"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          rules: [_vm.rules.required()],
                          label: "Hora de inicio de la interrupción",
                          type: "time",
                          required: "",
                          "prepend-icon": "mdi-clock-outline"
                        },
                        model: {
                          value: _vm.startHour,
                          callback: function($$v) {
                            _vm.startHour = $$v
                          },
                          expression: "startHour"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "nudge-right": 40,
                            transition: "scale-transition",
                            "offset-y": "",
                            "max-width": "290px",
                            "min-width": "290px"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "v-text-field",
                                    _vm._g(
                                      {
                                        attrs: {
                                          rules: [_vm.rules.required()],
                                          label:
                                            "Fecha de fin de la interrupción",
                                          readonly: "",
                                          "prepend-icon": "mdi-calendar",
                                          disabled: !_vm.dateStart
                                        },
                                        model: {
                                          value: _vm.dateEnd,
                                          callback: function($$v) {
                                            _vm.dateEnd = $$v
                                          },
                                          expression: "dateEnd"
                                        }
                                      },
                                      on
                                    )
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.dateEndMenu,
                            callback: function($$v) {
                              _vm.dateEndMenu = $$v
                            },
                            expression: "dateEndMenu"
                          }
                        },
                        [
                          _c("v-date-picker", {
                            attrs: {
                              locale: "es",
                              color: "#60BB46",
                              max: _vm.maxDate,
                              min: _vm.dateStartSelected,
                              "header-color": "rgb(64,139,56)",
                              "no-title": ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.setDateEnd($event)
                              }
                            },
                            model: {
                              value: _vm.dateEndSelected,
                              callback: function($$v) {
                                _vm.dateEndSelected = $$v
                              },
                              expression: "dateEndSelected"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          rules: [_vm.rules.required(), _vm.checkHours],
                          disabled: !_vm.dateStart,
                          label: "Hora de fin de la interrupción",
                          type: "time",
                          required: "",
                          "prepend-icon": "mdi-clock-outline"
                        },
                        model: {
                          value: _vm.endHour,
                          callback: function($$v) {
                            _vm.endHour = $$v
                          },
                          expression: "endHour"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { justify: "end", "no-gutters": "" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: { color: "green", loading: _vm.isLoading },
                  on: {
                    click: function() {
                      return _vm.register()
                    }
                  }
                },
                [
                  _c("v-icon", { staticClass: "ml-1" }, [
                    _vm._v("mdi-check-all")
                  ]),
                  _vm._v(" REGISTRAR ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }